import {NullableUndefinedString} from "../../../../types/nullable-types";
import {v4 as uuidv4} from "uuid";

export class InsuranceFeeNote {
    constructor(public readonly providerCode: string,
                providerParts: string[],
                passengerUniqueId?: string) {

        this._providerParts = providerParts.map(part => part.replaceAll("|", "{_}"));
        if(passengerUniqueId) {
            this._passengerUniqueId = passengerUniqueId;
        } else {
            this._passengerUniqueId = uuidv4();
        }
    }

    private _version: string = "1";

    private readonly _providerParts: string[];
    get providerParts(): string[] {
        return this._providerParts.map(part => part.replaceAll("{_}", "|"));
    }

    private readonly _passengerUniqueId: string;
    get passengerUniqueId(): string {
        return this._passengerUniqueId;
    }

    fromProviderParts(providerCode: string, providerParts: string[]): InsuranceFeeNote {
        const note = new InsuranceFeeNote(providerCode,  providerParts, this.passengerUniqueId);
        note._version = this._version;
        return note;
    }

    equals(other: InsuranceFeeNote | null): boolean {
        if(!other) {
            return false;
        }

        return this.providerCode === other.providerCode
            && this._passengerUniqueId === other._passengerUniqueId
            && this._version === other._version
            && this._providerParts.join("|") === other._providerParts.join("|");
    }

    toString(): string {
         return [
             "INS",
             "1",
             this.providerCode,
             this._passengerUniqueId,
             ...this._providerParts
         ].join("|");
    }

    public static tryParse(feeNote: NullableUndefinedString): InsuranceFeeNote | null {
        if(!feeNote) {
            return null;
        }

        const parts = feeNote.split("|");
        const noteType = parts[0]?.toUpperCase();

        if(noteType !== "INS") {
            return null;
        }

        const version = parts[1];

        const providerName = parts[2];
        const passengerUniqueId = parts[3];
        const providerParts = parts.slice(4);

        const note = new InsuranceFeeNote(providerName, providerParts, passengerUniqueId);
        note._version = version;
        return note;
    }
}